import { useState } from 'react';
import Select from "react-select";
import ApiService from '../../Core/Service/ApiService';
import './style.scss';
import { useEffect } from 'react';

const BrandSelect = (props) => {
    const {data, setData, error} = props;
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        ApiService.get('/brands').then(response=>{
            setBrands(response.data.brands?.map(brand=>({
                value: brand,
                label: brand
            })));
        })
    }, []);

    const handleBrandChange = (opt) => {
        setData(opt.value)
    }

    return (
    <div className="brand-select" style={{maxWidth: 500}}>
        <label>Brand:</label>
        <Select 
            className='mt-2'
            options={brands} 
            value={brands?.find(b=>b.value == data)} onChange={handleBrandChange} 
        />
        {error && <div className="error">{ error }</div>}
    </div>
    )
}

export default BrandSelect;